// extracted by mini-css-extract-plugin
module.exports = {"text":"_5060ff8"};